function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 4C6.6 4 3.6 5.5 1.6 7.8c-.8 1-.8 2.5 0 3.4 2 2.3 5 3.8 8.4 3.8 3.4 0 6.4-1.5 8.4-3.8.8-1 .8-2.5 0-3.4-2-2.3-5-3.8-8.4-3.8zM6.5 6.6C5.1 7.2 3.9 8.1 3 9.1c-.2.2-.2.6 0 .8.9 1.1 2.1 1.9 3.5 2.5-.6-.8-1-1.8-1-2.9 0-1.1.4-2.1 1-2.9zm7 5.8c1.4-.5 2.6-1.4 3.5-2.5.2-.2.2-.5 0-.8-.9-1.1-2.1-1.9-3.5-2.5.6.8 1 1.8 1 2.9 0 1.1-.4 2.1-1 2.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgEye;